export const orderInfos = {
  name: '프루떼',
  phoneNumber: '010-1234-5678',
};
